import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "menu", "openIcon", "closeIcon"];

  toggle() {
    const isOpen = !this.menuTarget.classList.contains("hidden");
    // Toggle visibility
    this.menuTarget.classList.toggle("hidden");

    // Update aria-expanded
    this.buttonTarget.setAttribute("aria-expanded", String(!isOpen));

    // Swap icons via Tailwind hidden class
    if (this.hasOpenIconTarget && this.hasCloseIconTarget) {
      this.openIconTarget.classList.toggle("hidden");
      this.closeIconTarget.classList.toggle("hidden");
    }

    // Lock body scroll when menu open
    if (!isOpen) {
      document.documentElement.classList.add("overflow-hidden");
      document.body.classList.add("overflow-hidden");
    } else {
      document.documentElement.classList.remove("overflow-hidden");
      document.body.classList.remove("overflow-hidden");
    }
  }
}
